'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { FormFieldContext } from '../form-field/context/form-field.context';
import { labelRecipe } from './styles/label.styles';
import type { LabelPropsInterface } from './types/label.types';

export const Label = forwardRef<HTMLLabelElement, LabelPropsInterface>(
  (props: LabelPropsInterface, forwardedRef) => {
    const formFieldContext = useContext(FormFieldContext);

    const {
      className,
      css: cssProp,
      disabled = formFieldContext.disabled || false,
      required = formFieldContext.required || false,
      optional = formFieldContext.optional || false,
      // TODO: inherit size from context
      size = 'md',
      ...rest
    } = props;

    const styles = css(labelRecipe.raw({ size, disabled, required, optional }), cssProp);

    return (
      <label
        aria-disabled={disabled || undefined}
        ref={forwardedRef}
        className={cx('c11n', styles, className)}
        data-c11n-component="Label"
        data-c11n-version={__C11N_VERSION__}
        id={formFieldContext.labelId}
        htmlFor={formFieldContext.controlId}
        {...rest}
      />
    );
  },
);

Label.displayName = 'Label';
